module.exports = __webpack_public_path__ + "img/reward.dcff7193.svg";